import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { QueryClient, QueryClientProvider } from 'react-query';

import { CustomToaster } from '../../../BaseUI';
import AddTopicForm from './AddTopicForm';
import TopicList from './TopicList';

const queryClient = new QueryClient();

const EditTopicsSettings = ({ identityId }) => {
  return (
    <QueryClientProvider client={queryClient}>
      <Row>
        <Col className="col-sm-12 col-md-12">
          <div className="prefs-section-header">
            <h3>Topics You Follow on the Information</h3>
          </div>
        </Col>
      </Row>

      <AddTopicForm identityId={identityId} />

      <Row className="mt3 mb4">
        <Col className="col-sm-12 col-md-12">
          <TopicList identityId={identityId} />
        </Col>
      </Row>

      <CustomToaster />
    </QueryClientProvider>
  );
};

export default EditTopicsSettings;
